import { useDispatch, useSelector } from "react-redux";
import {
  addAssignment,
  deleteAssignment,
  getAssignment,
  resetCurrentAssignment,
  setCurrentAssignment,
  setOffset,
  setPage,
  setPerPage,
  setRedirect,
  updatedAssignment,
  getClasses,
} from "../store/assignment";

export function useAssignment() {
  const dispatch = useDispatch();

  const assignments = useSelector((state) => state.assignment.data);
  const currentAssignment = useSelector(
    (state) => state.assignment.currentAssignment
  );
  const redirect = useSelector((state) => state.assignment.redirect);
  const perPage = useSelector((state) => state.assignment.perPage);
  const offset = useSelector((state) => state.assignment.offset);
  const page = useSelector((state) => state.assignment.page);
  const classData = useSelector((state) => state.assignment.classes);
  const loading = useSelector((state) => state.assignment?.loading);

  const getAssignmentAction = (params) => dispatch(getAssignment(params));
  const addAssignmentAction = (params) => dispatch(addAssignment(params));
  const deleteAssignmentAction = (params) => dispatch(deleteAssignment(params));
  const updatedAssignmentAction = (params) =>
    dispatch(updatedAssignment(params));
  const resetCurrentAssignmentAction = () => {
    dispatch(resetCurrentAssignment());
  };
  const setCurrentAssignmentAction = (params) =>
    dispatch(setCurrentAssignment(params));

  const setRedirectAction = (params) => dispatch(setRedirect(params));
  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));
  const getClassesAction = (params) => dispatch(getClasses(params));

  return {
    getAssignmentAction,
    addAssignmentAction,
    deleteAssignmentAction,
    updatedAssignmentAction,
    getClassesAction,
    assignments,
    resetCurrentAssignmentAction,
    setCurrentAssignmentAction,
    currentAssignment,
    setRedirectAction,
    redirect,
    setOffsetAction,
    setPerPageAction,
    setPageAction,
    classData,
    perPage,
    offset,
    page,
    loading,
  };
}
